<template>
<!--我的课程-->
  <div id="myclass">
    <person-head :title="title"></person-head>
    <div class="course">
      <router-link :to="{name: 'VideoPlay', query: {class_id: item.class_id}}" v-for="(item, index) in classData" :key="index">
        <h3 :title="item.name">{{item.name}}</h3>
        <div class="cc">
          <img :src="item.app_img_1" alt="">
          <div class="left">
            <h5 :title="item.name">{{item.name}}</h5>
            <p>{{item.name_main}}</p>
          </div>
          <div class="right">
            <img v-if="item.video_type === 1 || item.video_type === 2" src="../../assets/icon/myclass_icon_play.png" alt="">
            <img v-else src="../../assets/icon/videoplay_icon_play.png" alt="">
            <span v-if="item.video_type === 1" class="red">观看直播</span>
            <span v-else-if="item.video_type === 2" class="red">去学习</span>
            <span v-else>去听课</span>
          </div>
        </div>
      </router-link>
    </div>
    <div class="bg"></div>
  </div>
</template>

<script>
import personHead from '../share/header/personHead'
export default {
  name: 'MyClass',
  data () {
    return {
      classData: {},
      title: '我的课程'
    }
  },
  components: {
    personHead
  },
  methods: {
    getClass () {
      let data = {
        length: 100,
        page: 1
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_all_course',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.classData = res.data.data.info
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'MyClass'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted () {
    this.getClass()
  }
}
</script>

<style scoped lang="stylus">
#myclass
  .course
    padding: 0 .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a
      display: block
      width: 7.1rem
      height: 2.1rem
      background-color: #fff
      padding: 0 .2rem
      margin-top: .1rem
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      &:last-child
        margin-bottom: .2rem
      h3
        position: relative
        line-height: .6rem
        border-bottom: .02rem solid #CFD1D4
        overflow: hidden
        font-size: .3rem
        color: #333
        text-overflow: ellipsis
        white-space: nowrap
        font-weight: 600
        &::before
          content: ""
          display: none
          width: .08rem
          height: .28rem
          background-color: #1E81F2
          margin-right: .12rem
        &::after
          content: ""
          position: absolute
          top: .25rem
          right: .1rem
          display: block
          width: .1rem
          height: .1rem
          border-right: .02rem solid #666
          border-bottom: .02rem solid #666
          -webkit-transform: rotate(-45deg)
          -moz-transform: rotate(-45deg)
          -ms-transform: rotate(-45deg)
          -o-transform: rotate(-45deg)
          transform: rotate(-45deg)
      .cc
        display: flex
        justify-content: space-between
        align-items: center
        margin: .1rem 0
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        & > img
          width: 1.16rem
          height: 1.16rem
        .left
          width: 3.6rem
          h5
            display: none
            height: .44rem
            margin: .12rem auto
            overflow: hidden
            white-space: nowrap
            font-size: .28rem
            color: #353535
            font-weight: 400
            text-overflow: ellipsis
          p
            display: -webkit-box
            overflow: hidden
            -webkit-line-clamp: 2
            -webkit-box-orient: vertical
            font-size: .22rem
            color: #9DA4B3
        .right
          width: 1.5rem
          font-size: .22rem
          color: #9DA4B3
          text-align: center
          span
            &.red
              color: #FF7052
          & > img
            display: block
            width: .44rem
            height: .44rem
            margin: .12rem auto
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: -1
    width: 100%
    height: 100%
    background-color: #F7F7F7
</style>



// WEBPACK FOOTER //
// src/components/personal/MyClass.vue